<template>
  <div
    class="sb-embed"
    ref="iframe_wrapper"
    v-editable="editing && blok"
    :class="layout_classes"
  >
    <div class="sb-embed__inner" v-html="embed_code"></div>
  </div>
</template>
<script setup>
const props = defineProps({ blok: Object });
    const { editing } = useSettings();
    const iframe_wrapper = ref(null);
    const { getLayoutClasses } = useLayoutControl();
    const layout_classes = getLayoutClasses(props.blok);
let embed_code = props.blok.raw_html;

  const {icons,uiconfig,handleAnimation} = useUIControl()
onMounted(() => {

  if(props.blok.layout?.a_enabled)handleAnimation(iframe_wrapper,{type:'embed',layout:props.blok.layout,a:{...props.blok.layout.animation}});
})

</script>
<style lang="scss">
.sb-embed {
  &__inner {
  }
}
</style>